import Notification from '../types/contexts/Notification';
import useAppState from './useAppState';

const useNotifications = (): Notification[] => useAppState().notifications;

export default useNotifications;
